import changes from './cleanup-changes-ms'

/** Pembersihan lukisan dengan AI (Fasa 5, pelan Task 10, reka bentuk §11). Placeholder sama dengan cleanup-en.ts. */
export default {
  title: 'Bersihkan lukisan saya dengan AI',
  intro:
    'Jika lukisan anda gagal dalam semakan lukisan, gisify boleh membantu anda membetulkannya sebelum anda menghantar. Lukisan asal disimpan, tiada apa yang dihantar, dan AI majlis membaca ringkasan lukisan, bukan fail itu sendiri.',
  link: 'Dapatkan bantuan membetulkan lukisan ini',
  round: 'Pusingan {{n}} daripada {{max}}',
  explanation: 'Catatan daripada AI',
  errorRow: '{{type}} pada lapisan {{layer}}',
  errorRowsMore: 'dan {{count}} lagi',
  start: {
    file: 'Lukisan (DWG atau DXF, sehingga {{mb}} MB)',
    crs: 'Sistem koordinat lukisan',
    button: 'Muat naik dan semak',
    uploading: 'Sedang memuat naik…',
    processedBy:
      'Lukisan asal disimpan, tiada apa yang dihantar, dan AI majlis ({{provider}}, {{where}}) membaca ringkasan lukisan, bukan fail itu sendiri.',
  },
  provider: {
    anthropic: 'API Anthropic',
    bedrock: 'Perkhidmatan AWS Bedrock',
    openai: 'Perkhidmatan OpenAI',
    ollama: 'Pelayan Ollama',
  },
  processedIn: {
    anthropic_api: 'diproses oleh Anthropic, di luar AWS',
    singapore_only: 'diproses di Singapura sahaja',
    united_states_only: 'diproses di Amerika Syarikat sahaja',
    any_aws_region: 'diproses di mana-mana rantau AWS yang dipilih oleh AWS',
    openai_api: 'diproses oleh OpenAI',
    own_server: 'diproses pada pelayan Ollama anda',
  },
  step: {
    queued: 'Menunggu untuk bermula…',
    reading: 'Sedang membaca lukisan…',
    checking: 'Sedang menjalankan semakan lukisan…',
    asking_ai: 'Sedang meminta cadangan daripada AI…',
    applying: 'Sedang menggunakan perubahan anda…',
    writing: 'Sedang menyimpan lukisan baharu…',
  },
  failures: {
    before: 'Masalah pada permulaan',
    now: 'Masalah sekarang',
    none: 'Lukisan ini lulus semakan.',
    onLayer: 'pada {{layer}}',
    count: '{{count}} ditemui',
  },
  status: {
    uploading: 'Lukisan tidak selesai dimuat naik. Hentikan pembersihan ini dan mulakan semula.',
    stopped: 'Pembersihan ini telah dihentikan.',
    failed: 'Pembersihan ini tidak dapat diteruskan.',
    submitted: 'Lukisan yang dibersihkan kini menjadi lukisan kes ini. Hantarkannya seperti biasa.',
    expired: 'Pembersihan ini ditutup selepas 7 hari tanpa aktiviti.',
    superseded: 'Pembersihan ini adalah untuk semakan kes yang lebih awal dan telah ditutup.',
  },
  batch: {
    title: 'Pembetulan yang ditemui oleh gisify',
    accept: 'Terima semua ini',
    saveR2000: 'Simpan sebagai AutoCAD 2000: tinggalkan ruang kertas dan {{count}} item lain',
    saveR2000Detail:
      'Ditinggalkan: {{paperSpace}} item ruang kertas, {{objects}} objek, {{displayCodes}} tetapan paparan, {{xdata}} data lanjutan, {{reactors}} pautan dan {{layers}} lapisan yang tidak digunakan.',
    held: '{{count}} lagi pembetulan akan ditawarkan dalam pusingan seterusnya.',
    textToMtextUntick:
      'Tanpa ini, fail baharu tidak dapat menyimpan label ini: pusingan akan berhenti sehingga anda menandakannya atau membetulkannya dalam CAD.',
  },
  op: {
    rename_layer: 'Namakan semula lapisan {{from}} kepada {{to}}',
    explode_inserts: 'Pecahkan {{count}} blok pada {{layer}} kepada bentuk-bentuknya',
    scale_units: 'Tukar lukisan daripada {{unit}} kepada meter',
    close_outline: 'Tutup garis luar pada {{layer}} (jurangnya kurang daripada 1 mm)',
    join_pieces:
      'Cantumkan garisan pada {{layer}} yang bertemu hujung ke hujung menjadi garis luar tunggal ({{count}} kesemuanya)',
    show_layer: 'Hidupkan lapisan {{layer}}',
    remove_empty_layer: 'Buang lapisan kosong {{layer}}',
    remove_degenerate: 'Buang {{count}} bentuk berpanjang sifar pada {{layer}}',
    remove_duplicate: 'Buang {{count}} bentuk pendua pada {{layer}}',
    text_to_mtext:
      'Simpan {{count}} label pada {{layer}} sebagai teks berbilang baris, supaya AutoCAD 2000 dapat mengekalkan aksaranya (perkataannya tidak berubah)',
  },
  unit: { m: 'meter', mm: 'milimeter', cm: 'sentimeter', ft: 'kaki' },
  question: {
    title: 'Soalan {{n}} daripada {{total}}',
    guess: 'Jawapan yang dicadangkan',
    reason: 'Sebabnya',
    byRule: 'Dicadangkan oleh gisify',
    byAi: 'Dicadangkan oleh AI',
    accept: 'Terima',
    change: 'Pilih jawapan lain',
    skip: 'Langkau',
    choose: 'Jawapan anda',
    previous: 'Soalan sebelumnya',
    next: 'Soalan seterusnya',
    answeredAccept: 'Anda telah menerima ini.',
    answeredReject: 'Anda telah melangkau ini.',
    allAnswered: 'Setiap soalan telah dijawab. Tekan Gunakan apabila anda bersedia.',
    layers: 'Lapisan: {{layers}}',
  },
  ask: {
    choose_site_boundary: 'Bentuk manakah sempadan tapak?',
    assign_layer: 'Lapisan piawai manakah sepatutnya {{layer}}?',
    assign_shapes: 'Lapisan guna tanah manakah tempat {{count}} bentuk ini?',
    set_units: 'Dalam unit apakah lukisan ini dilukis?',
    attach_label: 'Plot manakah milik label {{text}}?',
    label_plot: 'Apakah guna tanah plot ini?',
    remove_layers: 'Buang lapisan ini ({{group}})?',
    remove_entities: 'Buang item {{type}} pada {{layer}}? gisify tidak dapat menyimpannya dalam fail baharu.',
  },
  answer: { shape: 'Bentuk {{id}}', remove: 'Buang semuanya' },
  group: { title_block: 'blok tajuk', dimensions: 'dimensi', furniture: 'perabot', other: 'lain-lain' },
  ruleReason: {
    writer_cannot_carry:
      'Fail AutoCAD 2000 tidak dapat menyimpan item ini. Buangnya di sini, atau betulkannya dalam CAD dan muat naik semula.',
  },
  pointOut: {
    title: 'Betulkan ini dalam CAD',
    help: 'gisify tidak mengalihkan titik atau kawasan. Betulkan ini dalam program CAD anda, kemudian muat naik semula.',
    fixInCad: 'Betulkan ini dalam CAD',
    outsideJurisdiction:
      'Lukisan ini tidak berada di kawasan majlis. Semak sistem koordinat yang anda pilih, atau letakkan lukisan dengan alat peletakan.',
    kind: {
      block_too_large: 'Blok ini terlalu besar untuk dipecahkan di sini. Letupkannya dalam CAD.',
      arc_chain: 'Kepingan ini mengandungi lengkok, yang tidak dicantumkan oleh gisify. Cantumkannya dalam CAD.',
      too_large: 'Perubahan ini terlalu besar untuk dibuat oleh pembersihan dalam satu pusingan. Buatnya dalam CAD.',
    },
  },
  view: {
    title: 'Lukisan anda',
    loading: 'Sedang memuatkan lukisan…',
    failed: 'Lukisan tidak dapat dipaparkan.',
    cut: 'Sebahagian lukisan tidak dipaparkan di sini: ia mempunyai lebih banyak titik daripada yang dilukis oleh paparan ini.',
    role: {
      site_boundary: 'Sempadan tapak',
      landuse: 'Guna tanah',
      labels: 'Teks label guna tanah',
      context: 'Butiran sokongan',
      other: 'Lapisan lain',
    },
  },
  actions: {
    apply: 'Gunakan',
    use: 'Guna lukisan ini',
    useNote:
      'Lukisan yang dibersihkan menjadi lukisan anda untuk kes ini. Anda masih menghantar seperti biasa, dan semakan biasa dijalankan.',
    download: 'Muat turun DXF yang dibersihkan',
    revert: 'Kembali ke pusingan {{n}}',
    stop: 'Hentikan',
    retry: 'Cuba lagi',
  },
  ai: {
    failed: 'AI tidak dapat mencadangkan pembetulan. Cuba lagi.',
    limit: 'Hubungi majlis anda untuk meneruskan.',
    roundFull: 'Pusingan ini tiada ruang lagi untuk cadangan AI. AI akan ditanya dalam pusingan seterusnya.',
  },
  limit: {
    rounds:
      'Anda telah menggunakan kesemua 10 pusingan. Betulkan masalah yang tinggal dalam CAD, atau muat turun DXF yang dibersihkan sebahagiannya.',
  },
  refusal: {
    not_home_tenant: 'Pembersihan ini hanya boleh digunakan oleh pengguna majlis ini.',
    not_found: 'Kes ini tidak dapat ditemui.',
    actor_not_permitted: 'Hanya perunding yang memiliki kes ini boleh membersihkan lukisannya.',
    drawing_cleanup_off: 'Majlis telah mematikan pembersihan lukisan.',
    ai_not_configured: 'Majlis belum menyediakan AI untuk pembersihan lukisan.',
    ai_region_unavailable: 'Pilihan AI majlis tidak lagi ditawarkan. Minta majlis memilihnya semula.',
    register_server_not_configured: 'Majlis belum selesai menyediakan semakan lukisannya.',
    stage_held_externally: 'Sistem lain memegang kes ini, jadi lukisannya tidak boleh diubah di sini.',
    stage_locked: 'Lukisan kes ini tidak boleh diubah pada peringkat ini.',
    body_invalid: 'Permintaan itu tidak dapat dibaca. Muat semula halaman dan cuba lagi.',
    upload_rejected: 'Fail itu tidak boleh dibersihkan.',
    cleanup_not_found: 'Pembersihan ini tidak dapat ditemui. Muat semula halaman.',
    cleanup_in_progress: 'Satu pembersihan sudah dibuka untuk kes ini.',
    cleanup_closed: 'Pembersihan ini telah ditutup.',
    upload_missing: 'Lukisan tidak tiba sepenuhnya. Mulakan semula.',
    cleanup_busy: 'Satu pusingan masih berjalan. Tunggu sehingga ia selesai.',
    round_mismatch: 'Pembersihan ini telah bergerak ke hadapan. Muat semula halaman untuk melihat pusingan semasa.',
    answer_invalid: 'Jawapan itu tidak boleh digunakan.',
    revert_invalid: 'Pusingan itu tidak lagi boleh dikembalikan.',
    retry_not_offered: 'Tiada apa yang perlu dicuba lagi.',
    round_limit: 'Kesemua 10 pusingan telah digunakan.',
    nothing_to_use: 'Belum ada perubahan yang digunakan.',
    cleanup_use_failed: 'Lukisan yang dibersihkan tidak dapat diletakkan pada kes ini. Cuba lagi.',
    edit_invalid:
      'Satu perubahan tidak lagi sesuai dengan lukisan, jadi pusingan itu dibatalkan. Semak jawapan anda dan gunakan semula.',
    unsupported_entities:
      'Fail baharu tidak dapat menyimpan beberapa item. Buangnya melalui soalan di sini, tandakan pembetulan yang mengekalkannya, atau betulkannya dalam CAD.',
    too_complex:
      'Lukisan ini terlalu besar atau terlalu rumit untuk dibersihkan di sini. Simpannya dalam CAD dengan lebih sedikit blok, atau pisahkannya.',
    check_not_run: 'Semakan lukisan tidak dapat dijalankan. Cuba lagi.',
    round_timeout: 'Pusingan mengambil masa terlalu lama dan telah dihentikan. Cuba lagi.',
    unreadable_file: 'Lukisan tidak dapat dibaca. Simpan semula dalam CAD dan mulakan pembersihan baharu.',
    stopped: 'Pusingan telah dihentikan.',
  },
  uploadRejected: {
    too_large: 'Fail itu lebih besar daripada yang dibenarkan oleh majlis.',
    empty: 'Fail itu kosong.',
    unsupported_type: 'Fail itu bukan lukisan DWG atau DXF seperti yang dinyatakan oleh namanya.',
  },
  answerInvalid: {
    needs_item: 'Jawapan ini memerlukan pembetulan yang anda nyahtanda atau soalan yang tidak anda terima.',
    conflicts_item: 'Jawapan ini bercanggah dengan pembetulan yang ditandakan.',
    nothing_accepted: 'Terima sekurang-kurangnya satu pembetulan atau jawapan sebelum anda menggunakannya.',
  },
  changes,
} as const
